import get from 'lodash/get';
import omit from 'lodash/omit';
import BaseModel from '../../common/models/base.model';

class Warranty extends BaseModel {
  schema = {
    car: this.yup.number().integer().required(this.requiredText),
    price: this.yup.number().integer().required(this.requiredText),
    dictWarrantyType: this.yup.number().integer().required(this.requiredText),
    dateFrom: this.yup.string().required(this.requiredText),
  }

  getData() {
    return {
      ...omit(this.data, 'warrantyType'),
      dictWarrantyType: get(this.data, 'warrantyType.id'),
      options: get(this.data, 'options', []).map((option) => ({ dictWarrantyOption: option.id, price: option.price })),
      dateFrom: get(this.data, 'dateFrom'),
    };
  }
}

export default Warranty;
